import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useUser from './useUser';

interface UserAuthentication {
  canUpdateCampaign: () => boolean;
  canApproveCampaign: () => boolean;
  canCreateCustomRules: () => boolean;
}

const useUserAuthorisation = (): UserAuthentication => {
  const { teamId } = useParams();
  const userData = useUser();

  return useMemo(() => ({
    canUpdateCampaign: (): boolean => {
      if (!teamId) {
        return true;
      }

      const writePermissionRole = `${teamId}:write`;
      return userData.roles.includes(writePermissionRole);
    },
    canApproveCampaign: (): boolean => {
      if (!teamId) {
        return true;
      }

      const approvePermissionRole = `${teamId}:approve`;
      return userData.roles.includes(approvePermissionRole);
    },

    canCreateCustomRules: (): boolean => {
      if (!teamId) {
        return false;
      }
      const customRuleAdminRole = `${teamId}:custom_rule_admin`;
      return userData.roles.includes(customRuleAdminRole);
    },
  }), [teamId, userData.roles]);
};

export default useUserAuthorisation;
